// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBarAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var compose = require('recompose').compose;
  var withProps = require('recompose').withProps;
  var withHandlers = require('recompose').withHandlers;
  var setPropTypes = require('recompose').setPropTypes;
  var PropTypes = require('react').PropTypes;
  var connect = require('share/enhancers/Izenda.Connect');
  var constants = require('logic/data/Izenda.UserAccountConstants');
  var observer = require('mobx-react').observer;
  var commonMessage = require('share/messages/Izenda.CommonMessages');
  var PasswordOptions = require('./Izenda.PasswordOptions');
  const { curry } = require('lodash/fp');
  var actionBarAction = compose(
    setPropTypes({
      store: PropTypes.object.isRequired,
      onSave: PropTypes.func.isRequired,
      onCancel: PropTypes.func.isRequired
    }),
    connect(),
    withHandlers({
      onClickPasswordOptions: curry(onClickPasswordOptions)
    })
  );

  /**
   * Click Password Options
   */
  function onClickPasswordOptions(props, e) {
    props.openPopup(PasswordOptions, { store: props.store });

    props.store.configUserCloned.addEmailRecipient();
  }

  module.exports = actionBarAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/UserSetup/ActionBar/Izenda.ActionBarAction.js